import requests from "./httpService";

const FranchiseServices = {
  createFranchise(brandId, franchiseData) {
    return requests.post(`/api/brands/${brandId}/franchises`, franchiseData);
  },
  getAllFranchises() {
    return requests.get(`/api/franchises`);
  },
  getBrandFranchises(brandId) {
    return requests.get(`/api/brands/${brandId}/franchises`);
  },
  getFranchise(brandId, id) {
    return requests.get(`/api/brands/${brandId}/franchises/${id}`);
  },
  updateFranchise(brandId, id, franchiseData) {
    return requests.put(
      `/api/brands/${brandId}/franchises/${id}`,
      franchiseData
    );
  },
  deleteFranchise(brandId, id) {
    return requests.delete(`/api/brands/${brandId}/franchises/${id}`);
  },
  getUserFranchises() {
    return requests.get("/api/franchises/user");
  },
};

export default FranchiseServices;
